import yup from '@/utils/yup'
import moment from 'moment'

export function newProviderSchema() {
  return yup.object().shape({
    provider: yup.string().required('Campo de preenchimento obrigatório'),
    name: yup.string().required('Campo de preenchimento obrigatório'),
    contact: yup.string().required('Campo de preenchimento obrigatório'),
    email: yup.string().required('Campo de preenchimento obrigatório')
  })
}

export function newBreakdownSchema() {
  return yup.object().shape({
    category: yup.string().nullable(),
    breakdown: yup.string().required('Campo de preenchimento obrigatório'),
    value: yup.string(),
    description: yup.string()
  })
}

export function newServiceSchema() {
  return yup.object().shape({
    id: yup.string(),
    category: yup.string(),
    service: yup.string().required('Campo de preenchimento obrigatório'),
    inspectionPhotoId: yup.string(),
    value: yup
      .number()
      .required('Campo de preenchimento obrigatório')
      .positive('Campo de preenchimento obrigatório')
  })
}

export function newProductDataSchema() {
  return yup.object().shape({
    produto: yup.string().required('Campo de preenchimento obrigatório'),
    avaria: yup.string(),
    valorOrcado: yup
      .number()
      .required('Campo de preenchimento obrigatório')
      .positive('Campo de preenchimento obrigatório')
  })
}

export function newPreparationFinalizeShema() {
  return yup.object().shape({
    codigoOM: yup.string(),
    dataEnvioPrestador: yup
      .date()
      .nullable()
      .required('Campo de preenchimento obrigatório')
      .typeError('Preencha uma data válida')
      .test(
        'is-valid-date',
        'A data deve ser atual ou anterior',
        function (value) {
          if (!value) return false

          const currentDate = moment()
          const inputDate = moment(value)

          if (inputDate.isAfter(currentDate, 'day')) return false

          const currentTime = moment()

          if (currentTime.hour() === 0 && currentTime.minute() === 0)
            return false

          return true
        }
      ),
    dataPrevistaConclusao: yup
      .date()
      .nullable()
      .required('Campo de preenchimento obrigatório')
      .typeError('Preencha uma data válida')
      .test(
        'is-valid-date',
        'A data deve ser atual ou posterior',
        function (value) {
          if (!value) return false

          const currentDate = moment()
          const inputDate = moment(value)

          if (inputDate.isBefore(currentDate, 'day')) return false

          if (inputDate.isBefore(currentDate, 'day')) return false

          return true
        }
      )
  })
}
